import { HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../modules/auth/auth.service';
import { catchError, map, throwError } from 'rxjs';
import { CryptoService } from '../services/crypto.service';
import { Router } from '@angular/router';
import { SnackBarService } from '@fuse/services/snack-bar/snack-bar.service';
import { API_ENDPOINTS } from '../helper/request-url-config';

export const HttpInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next) => {
    if (req.url.includes('.svg') || req.url.includes('i18n')) {
        return next(req); // Bypass interceptor for SVG files
    }
    const authService = inject(AuthService);
    const _SnackBarService = inject(SnackBarService);
    const cryptoService = inject(CryptoService);
    const route: Router = inject(Router);
    const isEncrypted = false;
    const silentToastEndpoints = [
        API_ENDPOINTS.user.settings,
        API_ENDPOINTS.dashboards.getEmployeeBirthdaysList,
        API_ENDPOINTS.dashboards.getEmployeeCalendar,
        API_ENDPOINTS.dashboards.checkInStatus,
    ];
    const shouldSuppressToast = silentToastEndpoints.some((endpoint) =>
        req.url.includes(endpoint)
    );

    let modifiedReq = req;
    const token = authService?.loginAccessToken;
    const storedToken = authService.getAccessToken();
    let accessToken = '';
    if (storedToken) {
        const parsedToken = JSON.parse(storedToken);
        accessToken = parsedToken?.accessToken || '';
    }
    const type = authService.userDetail?.token?.token_type || 'Bearer';
    // Handle the scenario where the body is FormData
    const isFormData = req.body instanceof FormData;

    // let btoa_two = '';
    // try {
    //     if (token && token.split('.').length === 3) {
    //         const decodedToken: any = jwtDecode(token);
    //         const raw = decodedToken?.someEncodedField; // Adjust this
    //         if (raw) {
    //             const btoa_one = atob(raw);
    //             btoa_two = atob(btoa_one);
    //         }
    //     }
    // } catch (error) {
    //     console.error('JWT Decode Error:', error);
    // }

    let additionalBody = {};
    if (token && !storedToken) {
        additionalBody = { token: token };
        // loginsession: btoa_two
    }

    if (!req.body || (req.body && !isFormData)) {
        const existingBody = req.body || {};
        const mergedBody = { ...existingBody, ...additionalBody };

        modifiedReq = req.clone({
            body: mergedBody,
            setHeaders: {
                Authorization: `${type} ${accessToken}`,
            },
        });
    } else if (isFormData) {
        modifiedReq = req.clone({
            setHeaders: {
                Authorization: `${type} ${accessToken}`,
            },
        });
    } else {
        // Fallback: Just set header if nothing else
        modifiedReq = req.clone({
            setHeaders: {
                Authorization: `${type} ${accessToken}`,
            },
        });
    };

    return next(modifiedReq).pipe(
        map((response: any) => {
            if (!(response instanceof HttpResponse)) return response;
            if (response.body instanceof Blob) return response;
            const isUnauthorized = response?.body?.code === 401 || response?.status === 401;
            
            if (isUnauthorized) {
                sessionStorage.removeItem('loginAccessToken');
                sessionStorage.removeItem('access_token');
                route.navigate(['/login']);
                if (!shouldSuppressToast) {
                    _SnackBarService.error(response?.body?.message || 'Unauthorized', 'Error');
                }
                return response;
            };

            if (isEncrypted && response?.body?.data) {
                try {
                    const decrypted = JSON.parse(cryptoService.Decrypt(response.body.data));
                    if (decrypted?.message && !shouldSuppressToast) {
                        _SnackBarService.success(decrypted.message,'Success');
                    }

                    return response.clone({ body: decrypted });
                } catch (err) {
                    console.error('Decryption failed:', err);
                    if (!shouldSuppressToast) {
                        _SnackBarService.error('Decryption failed', 'Error');
                    }
                    return response;
                };
            };

            if (response?.body?.message && !shouldSuppressToast) {
                _SnackBarService.success(response.body.message,'Success');
            };
            return response;
        }),
        catchError(error => {
            const isUnauthorized = error?.error?.code === 401 || error?.status === 401;

            if (isUnauthorized) {
                sessionStorage.removeItem('loginAccessToken');
                sessionStorage.removeItem('access_token');
                route.navigate(['/login']);
            };

            if (!shouldSuppressToast) {
                if (error?.error?.message) {
                    _SnackBarService.error(error.error.message, 'Error');
                } else {
                    _SnackBarService.error('An error occurred', 'Error');
                }
            };
            return throwError(() => error);
        })
    );

};
